module.exports = __webpack_public_path__ + "img/icon-4.778a5d67.png";